import React, {useMemo} from 'react';

export interface ArrowMarkerProps {
  x: number;
  y: number;
  width: number;
  height: number;
  color?: string;
  rotation?: number;
  opacity?: number;
  borderWidth?: number;
  borderColor?: string;
}

export const ArrowMarker: React.FC<ArrowMarkerProps> = ({
  x,
  y,
  width,
  height,
  color = '#ff0000',
  rotation = 0,
  opacity = 1,
  borderWidth = 0,
  borderColor = '#000000',
}) => {
  const arrowPath = useMemo(() => {
    const shaftWidthStart = Math.max(height * 0.05, 1.5);
    const shaftWidthEnd = Math.max(height * 0.2, 4);
    const minDimension = Math.min(width, height);
    const headLength = Math.max(minDimension * 0.45, 30);
    const headWidth = Math.max(minDimension * 0.5, 30);
    const actualHeadLength = Math.min(headLength, width * 0.45);
    const actualHeadWidth = Math.min(headWidth, height * 1.1);
    const centerY = height / 2;
    const shaftEndX = Math.max(width - actualHeadLength, width * 0.65);
    const shaftStartTop = centerY - shaftWidthStart / 2;
    const shaftStartBottom = centerY + shaftWidthStart / 2;
    const shaftEndTop = centerY - shaftWidthEnd / 2;
    const shaftEndBottom = centerY + shaftWidthEnd / 2;
    const tipX = width;
    const headBaseTop = centerY - actualHeadWidth / 2;
    const headBaseBottom = centerY + actualHeadWidth / 2;

    return `
      M 0 ${shaftStartTop}
      L ${shaftEndX} ${shaftEndTop}
      L ${shaftEndX} ${headBaseTop}
      L ${tipX} ${centerY}
      L ${shaftEndX} ${headBaseBottom}
      L ${shaftEndX} ${shaftEndBottom}
      L 0 ${shaftStartBottom}
      Z
    `.trim();
  }, [height, width]);

  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y,
        width,
        height,
        opacity,
        transform: `rotate(${rotation}deg)`,
        pointerEvents: 'none',
      }}
    >
      <svg
        style={{width: '100%', height: '100%', display: 'block'}}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      >
        {borderWidth > 0 ? (
          <path
            d={arrowPath}
            fill="none"
            stroke={borderColor}
            strokeWidth={borderWidth * 2}
            strokeLinejoin="miter"
          />
        ) : null}
        <path d={arrowPath} fill={color} stroke="none" />
      </svg>
    </div>
  );
};
